(() => {
  if (window.miFreeSampleInitialized) return;
  const configElement = document.getElementById('MiFreeSampleConfig');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  window.miFreeSampleInitialized = true;
  const root = window.Shopify?.routes?.root || '/';
  let count = config.initialCount;
  let busy = false;
  let adding = false;
  let errorMessage = '';
  let scheduled = false;
  let pending = false;
  const samples = cart => cart.items.filter(item => String(item.product_id) === String(config.productId));

  function render() {
    document.querySelectorAll('.js-mi-free-sample').forEach(button => {
      button.hidden = count > 0;
      button.disabled = busy || count > 0;
      button.setAttribute('aria-busy', String(busy));
      const label = button.querySelector('.gift-button__text');
      if (label) {
        if (!label.dataset.originalText) label.dataset.originalText = label.textContent;
        const text = adding ? config.adding : label.dataset.originalText;
        if (label.textContent !== text) label.textContent = text;
      }
    });
    document.querySelectorAll('[data-mi-sample-status]').forEach(status => {
      const message = errorMessage || (count > 0 ? config.added : '');
      if (status.textContent !== message) status.textContent = message;
    });
  }

  async function readCart() {
    const response = await fetch(root + 'cart.js', { cache: 'no-store', credentials: 'same-origin' });
    if (!response.ok) throw new Error('Cart unavailable');
    return response.json();
  }

  async function mutate(action, body) {
    const api = window.themeCore?.CartApi;
    if (api) {
      const type = action === 'add' ? api.actions.ADD_TO_CART : api.actions.UPDATE_CART;
      return api.makeRequest(type, { ...body, noOpen: true });
    }
    const response = await fetch(root + 'cart/' + action + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
    });
    if (!response.ok) throw new Error('Cart update failed');
    const result = await response.json();
    window.themeCore?.EventBus?.emit('cart:refresh');
    return result;
  }

  async function reconcile(add) {
    let cart = await readCart();
    let items = samples(cart);
    if (add && !items.length) {
      await mutate('add', { id: config.variantId, quantity: 1 });
      cart = await readCart();
      items = samples(cart);
      if (!items.length) throw new Error('Sample not added');
    }
    if (items.reduce((total, item) => total + item.quantity, 0) > 1) {
      const updates = {};
      items.forEach((item, index) => { updates[item.key] = index === 0 ? 1 : 0; });
      await mutate('update', { updates });
      cart = await readCart();
      if (samples(cart).reduce((total, item) => total + item.quantity, 0) > 1) {
        throw new Error('Sample limit could not be applied');
      }
    }
    count = samples(cart).reduce((total, item) => total + item.quantity, 0);
    errorMessage = '';
  }

  async function run(add = false) {
    if (busy) { if (!add) pending = true; return; }
    busy = true;
    adding = add;
    errorMessage = '';
    render();
    try {
      if (navigator.locks) await navigator.locks.request('mineralissima-free-sample', () => reconcile(add));
      else await reconcile(add);
    } catch (error) {
      try {
        const cart = await readCart();
        count = samples(cart).reduce((total, item) => total + item.quantity, 0);
      } catch (readError) { count = 0; }
      errorMessage = config.error;
    } finally {
      busy = false;
      adding = false;
      render();
      if (pending) { pending = false; schedule(); }
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(() => { scheduled = false; run(); });
  }

  document.addEventListener('click', event => {
    const button = event.target.closest?.('.js-mi-free-sample');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!busy) run(true);
  }, true);

  new MutationObserver(render).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('pageshow', schedule);
  window.addEventListener('focus', schedule);
  let attempts = 0;
  function connect() {
    const bus = window.themeCore?.EventBus;
    if (bus) { bus.listen('cart:updated', schedule); bus.listen('cart:refresh', schedule); }
    else if (++attempts < 40) setTimeout(connect, 250);
  }
  connect();
  render();
  schedule();
})();
